
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./src/index.ts";
              export default OriginalModule.default;
              export * from "./src/index.ts";